import React from 'react';
import { useAppSelector } from 'hooks/redux';
import { Box, Typography } from '@mui/material';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { formatNumber } from 'store/actions/mainPage/constant';

ChartJS.register(ArcElement, Legend, Tooltip);

export const PieDiagram: React.FC<{
  width?: number;
  height?: number;
  fz?: string;
  animateRotate?: boolean;
}> = ({ width = 200, height = 200, fz, animateRotate = true }) => {
  const { statisticsData, lang } = useAppSelector((state) => state.mainPage);
  if (!statisticsData) {
    return null;
  }

  const data = {
    labels: statisticsData.data.map((item) => item.paramName),
    datasets: [
      {
        data: statisticsData.data.map((item) => +item.paramValue),
        backgroundColor: statisticsData.data.map((item) => item.color),
        borderWidth: 1,
        borderColor: '#000',
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (context) {
            const dataIndex = context.dataIndex;
            const unit =
              statisticsData.export.unit || statisticsData.data[dataIndex].unit;
            const _value = context.parsed.toString();
            const value = formatNumber(_value, lang);
            return `${value} ${unit}`;
          },
        },
      },
    },

    cutout: 0,
    responsive: false,
    animation: {
      animateRotate: animateRotate,
    },
    elements: {
      arc: {
        borderWidth: 0,
        hoverBorderWidth: 0,
      },
    },

    layout: {
      padding: {
        right: 5,
      },
    },
  };

  let titleWidth: string | number = 500;

  if (fz && width) {
    titleWidth = width * 1.5;
  } else {
    titleWidth = innerWidth < 600 ? '100vw' : '30vw';
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography
        sx={{
          textAlign: 'center',
          maxWidth: titleWidth,
          fontWeight: 700,
          fontSize: fz || 'inherit',
          flex: 1,
        }}
      >
        {statisticsData?.export.filename}
      </Typography>
      {/*@ts-ignore*/}
      <Pie data={data} options={options} width={width} height={height} />
    </Box>
  );
};
